import React, { useEffect } from 'react';
import { useSmoothScroll } from '../hooks/useSmoothScroll';
import KineticHero from '../components/KineticHero';
import StatsMarquee from '../components/StatsMarquee';
import ServicesSection from '../components/ServicesSection';
import FeaturesManifesto from '../components/FeaturesManifesto';
import CustomerStories from '../components/CustomerStories';
import CTASection from '../components/CTASection';

const HomePage = () => {
  useSmoothScroll();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-slate-950">
      <KineticHero />
      <StatsMarquee />
      <ServicesSection />
      <FeaturesManifesto />
      <CustomerStories />
      <CTASection />
    </div>
  );
};

export default HomePage;
